import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import Swal from 'sweetalert2';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeaderComponent } from '../../header/header.component';
import { FooterComponent } from '../../footer/footer.component';
import { DireccionDirective } from '../../../validaciones/directives/direccion.directive';
import { NameDirective } from '../../../validaciones/directives/name.directive';
import { NumericDirective } from '../../../validaciones/directives/numeric.directive';
import { AlphanumericDirective } from '../../../validaciones/directives/alphanumeric.directive';
import { PlacaDirective } from '../../../validaciones/directives/placa.directive';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { lettersDirective } from '../../../validaciones/directives/lettersDirective.directive';
import { CatEfectoCertificado } from '../../../service/catEfectoCertificado.service';
import { CatCoberturaCertificados } from '../../../service/catCoberturaCertificados.service';
import { SolicitarCertificadoForaneoFisica } from '../../../service/solicitarCertificadoForaneoFisica.service';
import { SolicitudVo } from '../../../pojos/solicitudVo';
import { ResponsePropietarioFisica } from '../../../pojos/responsePropietarioFisica';
import { combineLatest, debounceTime, distinctUntilChanged, filter, Subscription } from 'rxjs';
import { Localidades } from '../../../pojos/localidades.modelo';
import { CatologosGenericosService } from '../../../service/catalogosGenericos.service';
import { HttpErrorResponse, HttpEvent, HttpEventType } from '@angular/common/http';
import { DefaultErrorMessage, ErrorMessages } from '../../catalogoErrores/error-messages';
import { ImprimirSolicitudCdniGenerico } from '../../../service/imprimirSolicitudCdniGenerico.service';
import { DocumentoService } from '../../../service/cargarDocumentos.service';
import { EliminarDocumentos } from '../../../service/eliminarDocumentos.service';
import { ConsultarEstatusVehiculoService } from '../../../service/consultarEstatusVehiculoFisica.service';
import { EstatusVehiculoResponse } from '../../../pojos/estatusVehiculoResponse';
import { validadorReutilizable } from '../../../shared/utils/validadores';

@Component({
  selector: 'app-persona-fisica-foranea',
  imports: [
    ReactiveFormsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatOptionModule,
    HeaderComponent,
    FooterComponent,
    MatCheckboxModule,
    FormsModule,
    CommonModule,
    MatSelectModule,
    MatTooltipModule,
    MatIconModule,

    lettersDirective,
    DireccionDirective,
    NameDirective,
    NumericDirective,
    AlphanumericDirective,
    PlacaDirective,
  ],
  templateUrl: './persona-fisica-foranea.component.html',
  styleUrl: './persona-fisica-foranea.component.css'
})
export class PersonaFisicaForaneaComponent {

  @ViewChild('stepper') stepper!: MatStepper;
  @Input() estatusVehiculoResponse!: EstatusVehiculoResponse;
  @Input() solicitudVo!: SolicitudVo;
  @Input() efectosCertificados: any[] = [];
  @Input() coberturaCertificados: any[] = [];
  @Input() listLocalidades!: Localidades; //Modelo de localidades de servicio generico INEGI
  @Input() localidades: Array<any> = []; //Arreglo para recibir las localides del servicios de INEGI
  public estados: string[] = [];
  public municipios: string[] = [];
  public localidadesLista: string[] = [];
  @Input() localidadesVo!: Localidades;
  estado: string = '';
  municipio: string = '';
  uploadProgress: number[] = [0, 0, 0, 0];
  isUploading: boolean[] = [false, false, false, false];
  documentos = [
    {id: 8, titulo: 'SOLICITUD', formControlName: '',estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
    {id: 3, titulo: 'FACTURA', formControlName: '', estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
    {id: 4, titulo: 'INE', formControlName: '', estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
    {id: 7, titulo: 'REPUVE', formControlName: '', estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
    {id: 9, titulo: 'TENENCIA Y/O REFRENDO', formControlName: '', estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''}
  ];
  nombreArchivos: string[] = ['', '', '', '',''];
  documentosSubidos: { identificador: string; idDocumento: number; }[] = [];
  identificadoresAnteriores: string[] = []; // <-- ya lo manejas por índice
  idsDocumentoAnteriores: number[] = [];   // <-- también por índice
  private readonly STORAGE_KEY = 'persona-fisica-estatal-progress';
  //********************************************* INICIALIZADOR DE FORMGROUP ************************************************//

  PrimerFormGroup!: FormGroup;
  SegundoGrupo!: FormGroup;
  TercerFormGroup!: FormGroup;
  CuartoFormGroup!: FormGroup;
  QuintoFormGroup!: FormGroup;
  SextoFormGroup!: FormGroup;
  SeptimoFormGroup!: FormGroup;

  mostrarSpinner = false;
  isLinear = false;

  //********************************************* VARIABLES INICIALIZADAS PARA DOCUMENTOS PDF - IFRAME ************************************************//

  // SOLICITUD
  archivoPDF1: File | null = null;
  pdfURL1: any = null;
  // isUploading = false;
  // uploadProgress = 0;

  // FACTURA
  archivoPDF2: File | null = null;
  pdfURL2: any = null;
  isUploading2 = false;
  uploadProgress2 = 0;

  // INE
  archivoPDF3: File | null = null;
  pdfURL3: any = null;
  isUploading3 = false;
  uploadProgress3 = 0;

  // REPUVE
  archivoPDF4: File | null = null;
  pdfURL4: any = null;
  isUploading4 = false;
  uploadProgress4 = 0;

  // TENENCIA
  archivoPDF5: File | null = null;
  pdfURL5: any = null;
  isUploading5 = false;
  uploadProgress5 = 0;
  subscription!: Subscription;

  constructor(
    private _formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private catEfectoCertificadoService: CatEfectoCertificado,
    private catCoberturaCertificadoService: CatCoberturaCertificados,
    private solicitarCertificadoForenaeoService: SolicitarCertificadoForaneoFisica,
    private localidadesService: CatologosGenericosService,
    private imprimirSolicitudCdniGenerico: ImprimirSolicitudCdniGenerico,
    private cargarDocumentosService: DocumentoService,
    private eliminarDocumentosService: EliminarDocumentos,
    private consultarEstatusVehiculoService: ConsultarEstatusVehiculoService
  )
   {
      this.solicitudVo = new SolicitudVo();
      this.localidadesVo = new Localidades();
      this.catCoberturaCertificados();
      this.catEfectoCertificado();
   }

  //********************************************* VARIABLES INICIALIZADAS PARA VALIDAR CAMPOS VACIOS ************************************************//

  ngOnInit(): void {
    this.PrimerFormGroup = this._formBuilder.group({
      niv: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(17),
        ],
      ],
      placa: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(10),
        ],
      ],

      motivoSolicitud: ['', Validators.required],
      certificadoPor: ['', Validators.required],
      tipoServicio: ['', Validators.required],
      categoria: ['', Validators.required],
      marca: ['', Validators.required],
      submarca: ['', Validators.required],
      modelo: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4),],],
      motor: ['', Validators.required],
      refrendo: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4),],],
      repuve: ['', Validators.required],
    });

    this.SegundoGrupo = this._formBuilder.group({
      rfc: [
        '',
        [
          Validators.required,
          Validators.minLength(13),
          Validators.maxLength(13),
          Validators.pattern(/^[A-Z]{4}[0-9]{6}[A-Z0-9]{3}$/),
        ],
      ],
      curp: [
        '',
        [
          Validators.required,
          Validators.minLength(18),
          Validators.maxLength(18),
          Validators.pattern(
            /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
          ),
        ],
      ],
      nombre: ['', Validators.required],
      apellidoPaterno: ['', Validators.required],
      apellidoMaterno: ['', Validators.required],
      sexo: [{ value: '', disabled: true }, Validators.required],
      fechaNacimiento: [{ value: '', disabled: true }, Validators.required],
    });

    this.TercerFormGroup = this._formBuilder.group({
      calle: ['', Validators.required],
      numeroExterior: ['', Validators.required],
      numeroInterior: [''],
      codigoPostal: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5),],],
      estado: ['', Validators.required],
      municipio: ['', Validators.required],
      localidad: ['', Validators.required],
    });

    this.CuartoFormGroup = this._formBuilder.group({
      numeroTelefono: [
        '',
        [Validators.required, Validators.pattern(/^\d{10}$/)],
      ],
      correoElectronico: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]{3,}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          ),
        ],
      ],
    });

    this.QuintoFormGroup = this._formBuilder.group({
      descargarDocumento: [false, Validators.requiredTrue],
    });

    this.SextoFormGroup = this._formBuilder.group({
      solicitud: ['', Validators.required],
      factura: ['', Validators.required],
      ine: ['', Validators.required],
      repuve2: ['', Validators.required],
      tenencia: ['', Validators.required],
    });

    this.SeptimoFormGroup = this._formBuilder.group({
      terminosCondiciones: [false, Validators.requiredTrue],
    });

    //********************************************* VALIDACIONES REACTIVAS 1-3 ************************************************//

    // 🔹 Aplicamos validaciones en tiempo real a TODOS los formularios
    this.inicializarValidacionesReactivas(this.PrimerFormGroup);
    this.inicializarValidacionesReactivas(this.SegundoGrupo);
    this.inicializarValidacionesReactivas(this.TercerFormGroup);
    this.inicializarValidacionesReactivas(this.CuartoFormGroup);
    this.inicializarValidacionesReactivas(this.QuintoFormGroup);
    this.inicializarValidacionesReactivas(this.SextoFormGroup);
    this.inicializarValidacionesReactivas(this.SeptimoFormGroup);

    //this.escucharCodigoPostal();

    this.restaurarEstado();

    [
    this.PrimerFormGroup,
    this.SegundoGrupo,
    this.TercerFormGroup,
    this.CuartoFormGroup,
    this.QuintoFormGroup,
    this.SextoFormGroup
  ].forEach(form =>
    form.valueChanges
      .pipe(debounceTime(500))
      .subscribe(() => this.guardarEstado())
  );

    //********************************************* VALIDACION DE NIV Y PLACA PARA OBTENER ESOS VALORES ************************************************//
      const nivControl = this.PrimerFormGroup.get('niv');
      const placaControl = this.PrimerFormGroup.get('placa');

      if (nivControl && placaControl) {
        combineLatest([
          nivControl.valueChanges.pipe(debounceTime(300), distinctUntilChanged()),
          placaControl.valueChanges.pipe(debounceTime(300), distinctUntilChanged()),
        ])
      }

        this.subscription = this.PrimerFormGroup.valueChanges.pipe(
          debounceTime(600),
          distinctUntilChanged((prev, curr) =>
            prev.niv === curr.niv && prev.placa === curr.placa
          ),
          filter(val => val.niv?.trim().length > 0 && val.placa?.trim().length > 8)
        ).subscribe(val => {
          this.consultarEstatusVehiculo(val.niv, val.placa);
        })

    //********************************************* VALIDACION DE NIV Y PLACA PARA OBTENER ESOS VALORES ************************************************//


  //********************************************* VALIDACION DE CODIGO POSTAL PARA OBTENER ESOS VALORES ************************************************//
     this.TercerFormGroup.get('codigoPostal')?.valueChanges
    .pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter((valor: string) => valor?.length === 5)
    )
    .subscribe((codigoPostal: string) => {
      this.obtenerLocalidades(codigoPostal);
    });
 //********************************************* VALIDACION DE CODIGO POSTAL PARA OBTENER ESOS VALORES ************************************************//
    this.documentosSubidos = new Array(this.documentos.length).fill(null);
}

  guardarEstado(): void {
    if(!this.stepper) return;

    const estado = {
      stepIndex: this.stepper.selectedIndex,

      forms: {
        primer: this.PrimerFormGroup.getRawValue(),
        segundo: this.SegundoGrupo.getRawValue(),
        tercero: this.TercerFormGroup.getRawValue(),
        cuarto: this.CuartoFormGroup.getRawValue(),
        quinto: this.QuintoFormGroup.getRawValue(),
        sexto: this.SextoFormGroup.getRawValue()
      },

      documentos: this.documentos,
      identificadores: this.identificadoresAnteriores,
      idsDocumento: this.idsDocumentoAnteriores
    };

    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(estado));
  }


  private restaurarEstado(): void {
    const saved = sessionStorage.getItem(this.STORAGE_KEY);
    if (!saved) return;

    const estado = JSON.parse(saved);

    this.PrimerFormGroup.patchValue(estado.forms.primer);
    this.SegundoGrupo.patchValue(estado.forms.segundo);
    this.TercerFormGroup.patchValue(estado.forms.tercero);
    this.CuartoFormGroup.patchValue(estado.forms.cuarto);
    this.QuintoFormGroup.patchValue(estado.forms.quinto);
    this.SextoFormGroup.patchValue(estado.forms.sexto);

    this.documentos = estado.documentos ?? this.documentos;
  this.identificadoresAnteriores = estado.identificadores ?? [];
  this.idsDocumentoAnteriores = estado.idsDocumento ?? [];

  setTimeout(() => {
    this.stepper.selectedIndex = estado.stepIndex ?? 0;
  });
  }

  //******************METODOS y llamada a consumos de servicio********************************//
    consultarEstatusVehiculo(strNiv:string, strPlaca:string){
      this.mostrarSpinner = true;
      this.consultarEstatusVehiculoService.consultarEstatusVehiculo(strNiv,strPlaca).subscribe({
        next: (response: EstatusVehiculoResponse) =>{
          this.estatusVehiculoResponse = response;
          console.log(response);
          if(this.estatusVehiculoResponse.vehiculoError?.mensaje){
             Swal.fire({
                    icon: 'warning',
                    title: 'Advertencia',
                    html: `<b>Atención: ${this.estatusVehiculoResponse.vehiculoError.mensaje}.<br><br>Si tienes dudas, asiste a tu oficina recaudadora más cercana.`,
                    confirmButtonColor: '#04B404',
                    confirmButtonText: 'Confirmar',
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    allowOutsideClick: false,
                  });
          }else if (this.estatusVehiculoResponse.intCodigoHttp === 400) {
             Swal.fire({
                    icon: 'warning',
                    title: 'Advertencia',
                    html: `<b>Atención:</b> ${this.estatusVehiculoResponse.vehiculoError?.strMensaje}.`,
                    confirmButtonColor: '#04B404',
                    confirmButtonText: 'Confirmar',
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    allowOutsideClick: false,
                  });
          }
          this.mostrarSpinner = false;
        },
         error: (error: HttpErrorResponse) =>{
              this.mostrarSpinner = false;
            let message = DefaultErrorMessage;

            if(error instanceof HttpErrorResponse){
              const statusCode = error.status;

              // Si viene un código de error personalizado desde el backend:
                const customCode = error.error?.codigo; // <- Esto depende de tu backend

                if(customCode && ErrorMessages[customCode]){
                    message = ErrorMessages[customCode];
                }else if (ErrorMessages[statusCode]) {
                  message = ErrorMessages[statusCode];
                }
              }
             Swal.fire({
                icon: 'error',
                title: 'Error',
                text: message,

            });
            }
      });
    }



   catCoberturaCertificados(){
  this.catCoberturaCertificadoService.catCoberturaCertificado().subscribe({
    next: (data:any) => {
      this.coberturaCertificados = data;
    }
  });
 }


 catEfectoCertificado(){
  this.catEfectoCertificadoService.catEfectoCertificado().subscribe({
    next: (data: any) => {
      this.efectosCertificados = data;
    }
  });
}

 onChangeCoberturaCertificados(event:any){
  this.solicitudVo.strCertificadoPor = event.target.value;
}


 onChangeEfectoCertificado(event:any){
  this.solicitudVo.strMotivoSolicitud = event.target.value;
}

onChangeTipoServicio(event:any){
  this.solicitudVo.strTipoServicio = event.target.value;
}

obtenerLocalidades(codigoPostal: string): void {
   const cp = codigoPostal.padStart(5, '0');
  this.localidadesService.getLocalidades(cp).subscribe((data: any[]) => {
    this.localidades = data;

    if (data && data.length > 0) {
      const localidadSeleccionada = data[0];
      const estadoSeleccionado = localidadSeleccionada.descripcionidEstadoPais?.toUpperCase().trim();

      if(estadoSeleccionado === 'TLAXCALA'){
        Swal.fire({
          icon: 'error',
          title: 'Estado no Válido',
          html: `<b>Este es un trámite para vehículos foráneos.</b> Si su domicilio está en TLAXCALA, por favor utilice el trámite para vehículos ESTATALES.`,
          confirmButtonColor: '#d33',
          confirmButtonText: 'Aceptar',
          allowEscapeKey: false, // Deshabilita cerrar con ESC
          allowEnterKey: false, // Deshabilita cerrar con ENTER
          allowOutsideClick: false, // Deshabilita cerrar haciendo clic fuera
        });

        // Limpia los campos relacionados para evitar que se guarden
        this.TercerFormGroup.patchValue({
          estado: '',
          municipio: '',
          localidad: ''
        });

        return; // Evita continuar llenando los datos
      }

      this.localidadesVo.lonIdMunicipio = localidadSeleccionada.idMunicipioCodigoPostal;
      this.localidadesVo.intCodigoPostal = localidadSeleccionada.idCodigoPostal;
      this.localidadesVo.strLocalidad = localidadSeleccionada.asentamiento;
      this.localidadesVo.strMunicipio = localidadSeleccionada.descripcionIdMunicipioCodigoPostal;

      this.TercerFormGroup.patchValue({
        estado: localidadSeleccionada.descripcionidEstadoPais,
        municipio: localidadSeleccionada.descripcionIdMunicipioCodigoPostal,
        localidad: localidadSeleccionada.asentamiento
      });

      this.localidadesLista = data.map(loc => loc.asentamiento); // para el select
    }
  });
}

descargarDocumento() {
      const primerGrupo = this.PrimerFormGroup.getRawValue();
      const segundoGrupo = this.SegundoGrupo.getRawValue();
      const tercerGrupo = this.TercerFormGroup.getRawValue();

      const strNombreCompleto = `${segundoGrupo.nombre || ''} ${segundoGrupo.apellidoPaterno || ''} ${segundoGrupo.apellidoMaterno || ''}`.trim();
      const strRfc = segundoGrupo.rfc || '';
      const strCurp = segundoGrupo.curp || '';

      const calle = tercerGrupo.calle || '';
      const numExt = tercerGrupo.numeroExterior || '';
      const numInt = tercerGrupo.numeroInterior || '';
      const codigoPostal = tercerGrupo.codigoPostal || '';
      const strDomicilio = `${calle} ${numExt}${numInt ? ' Int ' + numInt : ''} ${codigoPostal}`.trim();

      const strMunicipio = tercerGrupo.municipio || '';
      const strEstado = tercerGrupo.estado || '';

      const motivoSeleccionado = this.coberturaCertificados.find(
      m => m.id_cobertura_certificado == primerGrupo.certificadoPor);
      const strGarantias = motivoSeleccionado?.certificado_por || '';

      const strNiv = primerGrupo.niv || '';
      const strPlaca = primerGrupo.placa || '';
      const strMarca = primerGrupo.marca || '';
      const strEstadoVehiculo = tercerGrupo.estado || '';
      const strModelo = primerGrupo.modelo || '';
      const strRefrendo = primerGrupo.refrendo || '';

      const tipoServicioId = primerGrupo.tipoServicio;
      const strTipoServicio = tipoServicioId === '1' ? 'PÚBLICO' : tipoServicioId === '2' ? 'PRIVADO' : '';

      const strNumeroMotor = primerGrupo.motor || '';
      const strRepuve = primerGrupo.repuve || '';

      const strRazonSocial = '';
      const strRfcRepresentante = '';
      const strTipoPersona = 'F';

    Swal.fire({
      html: `<h4>Descargando documento <b style="color: #A11A5C">SOLICITUD DE CERTIFICADO DE NO INFRACCIÓN</b><hr>espere un momento...</h4>`,
      didOpen: () => {
        Swal.showLoading();
      },
      timer: 4000,
      timerProgressBar: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });


    this.imprimirSolicitudCdniGenerico.imprimirSolicitudCdniGenerico(
    strNombreCompleto,
    strRfc,
    strRfcRepresentante,
    strRazonSocial,
    strCurp,
    strDomicilio,
    strMunicipio,
    strEstado,
    strGarantias,
    strNiv,
    strPlaca,
    strMarca,
    strEstadoVehiculo,
    strModelo,
    strRefrendo,
    strTipoServicio,
    strNumeroMotor,
    strRepuve,
    strTipoPersona).subscribe({
      next: (blob: Blob) =>{
    const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'solicitud_cdni_foraneo.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
        Swal.close();
      },
       error: (error) => {
      console.error();
      Swal.fire('Error', 'Ocurrió un error al generar el documento.', 'error');
    }
    });
  }


  subirDocumento(rfc: string, idDocumento: number, archivo: File, index: number): void {
  this.documentos[index].estadoSubida ='SUBIENDO';
    console.log("nombre", archivo);
  this.cargarDocumentosService.subirDocumentoPdf(rfc, idDocumento, archivo).subscribe({
    next: (event: HttpEvent<any>) => {
      if (event.type === HttpEventType.UploadProgress && event.total){
        const progreso = Math.round((100 * event.loaded) / event.total);
        this.isUploading[index] = true;
        this.uploadProgress[index] = progreso;
      } else if (event.type === HttpEventType.Response) {
        this.isUploading[index] = false;

        this.documentos[index].estadoSubida = 'SUBIDO';
        const respuesta = event.body; // Aquí accedes a la respuesta del servicio

         this.identificadoresAnteriores[index] = respuesta.identificador;
         this.idsDocumentoAnteriores[index] = respuesta.idDocumento;


         Swal.fire({
          icon: 'success',
          title: `${this.documentos[index].titulo} subido con éxito`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
    },
    error: () => {
      this.isUploading[index] = false;
      this.documentos[index].estadoSubida = 'ERROR';
      Swal.fire({
        icon: 'error',
        title: 'Error al subir documento',
        text: `No se pudo subir el documento ${this.documentos[index].titulo}.`,
        confirmButtonColor: '#A11A5C'
      });
    }
  });
}
 //*******************METODOS y llamada a consumos de servicio********************************//



  //********************************************* VALIDACIONES REACTIVAS 2-3 ************************************************//

  private inicializarValidacionesReactivas(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((campo) => {
      formGroup.get(campo)?.valueChanges.subscribe(() => {
        this.actualizarEstilosCampo(campo);
      });
    });
  }

  //********************************************* VALIDACIONES REACTIVAS 3-3 ************************************************//

  private actualizarEstilosCampo(campo: string) {
    const control =
      this.SeptimoFormGroup.get(campo) ||
      this.SextoFormGroup.get(campo) ||
      this.QuintoFormGroup.get(campo) ||
      this.CuartoFormGroup.get(campo) ||
      this.TercerFormGroup.get(campo) ||
      this.SegundoGrupo.get(campo) ||
      this.PrimerFormGroup.get(campo);

      if(!control) return;

    const fieldElement = document.querySelector(`[formControlName="${campo}"]`);

    if (fieldElement) {
      if (control.value && (control.valid || control.disabled)) {
        fieldElement.classList.remove('is-invalid');
        fieldElement.classList.add('is-valid');
      } else if (!control.value) {
        fieldElement.classList.remove('is-valid');
      fieldElement.classList.remove('is-invalid');
      } else {
        fieldElement.classList.add('is-invalid');
        fieldElement.classList.remove('is-valid');
      }
    }
  }

  //********************************************* STEPPER ************************************************//

  /** Validación y navegación **/
  validarYContinuar(campos: { grupo: FormGroup; nombres: string[] }) {
    let todosValidos = true;

    campos.nombres.forEach((campo) => {
      const control = campos.grupo.get(campo);
      const fieldElement = document.querySelector(
        `[formControlName="${campo}"]`
      );

      if(control){
        control.markAsTouched({onlySelf:true});
        control.updateValueAndValidity();
      }

      if (control && control.disabled) return;

      if (control && control.invalid && !control.disabled) {
        todosValidos = false;
        Swal.fire({
          html: this.mensajeError(campo),
          icon: 'warning',
          confirmButtonColor: '#A11A5C',
          confirmButtonText: 'Confirmar',
          didOpen: () => fieldElement?.classList.add('is-invalid'),
        });
      } else if (fieldElement && (control?.valid || control?.disabled)) {
        fieldElement.classList.remove('is-invalid');
        fieldElement.classList.add('is-valid');
      }
    });

    if (todosValidos) this.stepper.next();
  }

  //********************************************* MENSAJES PERSONALIZADOS ************************************************//

  mensajeError(campo: string): string {
    const mensajes: any = {
      //Primera seccion
      niv: 'El campo <b> NIV de los Datos del Vehículo </b> no debe estar vacío.',
      placa:
        'El campo <b> Placa de los Datos del Vehículo </b> no debe estar vacío.',
      motivoSolicitud:
        'El campo <b> Motivo Solicitud de los Datos del Vehículo </b> debe estar seleccionado.',
      certificadoPor:
        'El campo <b> Certificado Por: de los Datos del Vehículo </b> debe estar seleccionado.',
      tipoServicio:
        'El campo <b> Tipo Servicio de los Datos del Vehículo </b> debe estar seleccionado.',
      categoria:
        'El campo <b> Categoria de los Datos del Vehículo </b> no debe estar vacío.',
      marca:
        'El campo <b> Marca de los Datos del Vehículo </b> no debe estar vacío.',
      submarca:
        'El campo <b> Submarca de los Datos del Vehículo </b> no debe estar vacío.',
      modelo:
        'El campo <b> Modelo de los Datos del Vehículo </b> no debe estar vacío.',
      motor:
        'El campo <b> Motor de los Datos del Vehículo </b> no debe estar vacío.',
      refrendo:
        'El campo <b> Refrendo de los Datos del Vehículo </b> no debe estar vacío.',
      repuve:
        'El campo <b> Repuve de los Datos del Vehículo </b> no debe estar vacío.',

      //Segunda seccion
      rfc:
        'Por favor verifica que el campo <b> RFC </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato válido: </b> LLLL000000AAA',
      curp:
        'Por favor verifica que el campo <b> CURP </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato válido: </b> LLLL000000LLLLLLA0',
      nombre:
        'El campo <b> Nombre de los Datos Personales </b> no debe estar vacío.',
      apellidoPaterno:
        'El campo <b> Apellido Paterno de los Datos Personales </b> no debe estar vacío.',
      apellidoMaterno:
        'El campo <b> Apellido Materno de los Datos Personales </b> no debe estar vacío.',
      sexo:
        'El campo <b> Sexo de los Datos Personales </b> no debe estar vacío.',
      fechaNacimineto:
        'El campo <b> Fecha Nacimiento de los Datos Personales</b> no debe estar vacío.',

      //Tercera seccion
      calle:
        'El campo <b> Calle del Domicilio </b> no debe estar vacío.',
      numeroExterior:
        'El campo <b> Numero Exterior del Domicilio </b> no debe estar vacío.',
      codigoPostal:
        'El campo <b> Codigo Postal del Domicilio </b> no debe estar vacío.',
      estado:
        'El campo <b> Estado del Domicilio </b> debe estar seleccionado.',
      municipio:
        'El campo <b> Municipio del Domicilio </b> debe estar seleccionado.',
      localidad:
        'El campo <b> Localidad del Domicilio </b> debe estar seleccionado.',


      //Cuarta seccion
      correoElectronico:
        'Por favor verifica que el campo <b> Correo Electrónico de los Medios de Contacto </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato correo: </b> nombre@ejemplo.com',
      numeroTelefono:
        'El campo <b> Número Teléfono de los Medios de Contacto </b> debe contener 10 números.',

      //Quinta seccion
      descargarDocumento:
        'Para continuar a la sección de <b>Documentos</b> primero debes marcar el cuadro que aparece en la parte inferior de esta sección',

      //Sexta seccion
      solicitud: 'El documento <b>SOLICITUD</b> no ha sido seleccionado',
      factura: 'El documento <b>FACTURA</b> no ha sido seleccionado',
      ine: 'El documento <b>INE</b> no ha sido seleccionado',
      repuve2: 'El documento <b>REPUVE</b> no ha sido seleccionado',
      tenencia: 'El documento <b>TENENCIA Y/O REFRENDO</b> no ha sido seleccionado'
    };

    return mensajes[campo] || 'Campo inválido.';
  }

  //********************************************* BOTONES SIGUIENTE ************************************************//

  nextButtonClick() {
    this.validarYContinuar({
      grupo: this.PrimerFormGroup,
      nombres: [
        'repuve',
        'refrendo',
        'motor',
        'modelo',
        'submarca',
        'marca',
        'categoria',
        'tipoServicio',
        'certificadoPor',
        'motivoSolicitud',
        'placa',
        'niv',
      ],
    });
  }

  nextButtonClick2() {
    this.validarYContinuar({
      grupo: this.SegundoGrupo,
      nombres: ['fechaNacimiento', 'sexo', 'apellidoMaterno', 'apellidoPaterno', 'nombre', 'curp', 'rfc'],
    });
  }

  nextButtonClick3() {
    this.validarYContinuar({
      grupo: this.TercerFormGroup,
      nombres: ['localidad', 'municipio', 'estado', 'codigoPostal', 'numeroInterior', 'numeroExterior', 'calle'],
    });
  }

  nextButtonClick4() {
    this.validarYContinuar({
      grupo: this.CuartoFormGroup,
      nombres: ['correoElectronico', 'numeroTelefono'],
    });
  }

  nextButtonClick5() {
    this.validarYContinuar({
      grupo: this.QuintoFormGroup,
      nombres: ['descargarDocumento'],
    });
  }

  nextButtonClick6() {
    this.validarYContinuar({
      grupo: this.SextoFormGroup,
      nombres: ['tenencia', 'repuve2', 'ine', 'factura', 'solicitud'],
    });
  }


  nextButtonClick7() {

    this.validarYContinuar({
      grupo: this.SeptimoFormGroup,
      nombres: ['terminosCondiciones'],
    });

    const campo1 = this.SeptimoFormGroup.get('terminosCondiciones');

    const correo = this.CuartoFormGroup.get('correoElectronico')?.value;

    if (campo1 && !campo1.value) {
      Swal.fire({
        html: '<b>Debes Aceptar los Términos y Condiciones</b>',
        icon: 'warning',
        confirmButtonColor: '#A11A5C',
        confirmButtonText: 'Confirmar',
      });
      return;
    }

    const datosVehiculo = this.PrimerFormGroup.getRawValue();
    const datosPersona = this.SegundoGrupo.getRawValue();
    const datosDomicilio = this.TercerFormGroup.getRawValue();
    const datosContacto = this.CuartoFormGroup.getRawValue();

    const objetoFinal = {
      /**DATOS DEL VEHICULO**/
      "strNiv": datosVehiculo.niv,
      "strPlaca": datosVehiculo.placa,
      "intIdMotivoSolicitud": datosVehiculo.motivoSolicitud,
      "intIdCertificadoPor": datosVehiculo.certificadoPor,
      "intIdTipoServicio": datosVehiculo.tipoServicio,
      "intIdTipoTramite": 2,
      "strCategoria":datosVehiculo.categoria,
      "strMarca":datosVehiculo.marca,
      "strSubMarca":datosVehiculo.marca,
      "strModelo":datosVehiculo.modelo,
      "strMotor":datosVehiculo.motor,
      "strRefrendo":datosVehiculo.refrendo,
      "strRepuve":datosVehiculo.repuve,
      /**DATOS DEL VEHICULO**/

      /**DATOS DEL PROPIETARIO**/
      "strRfc": datosPersona.rfc,
      "strCurp": datosPersona.curp,
      "strNombre":datosPersona.nombre,
      "strApMaterno":datosPersona.apellidoMaterno,
      "strApPaterno":datosPersona.apellidoPaterno,
      "strSexo": datosPersona.sexo,
      "strFechaNacimiento": datosPersona.fechaNacimiento,
      /**DATOS DEL PROPIETARIO**/

      /**DOMICILIO**/
      "strCalle": datosDomicilio.calle,
      "strNumeroExterior": datosDomicilio.numeroExterior,
      "strNumeroInterior": datosDomicilio.numeroInterior,
      "strCodigoPostal": datosDomicilio.codigoPostal,
      "strEstadoFiscal": datosDomicilio.estado,
      //"strMunicipio": datosDomicilio.municipio,
      "strLocalidad": datosDomicilio.localidad,
      "intIdCodigoPostalCg": parseInt(this.localidadesVo.intCodigoPostal),
      "intIdLocalidadFiscal": this.localidadesVo.intCodigoPostal,
      "intIdMunicipioFiscal": parseInt(this.localidadesVo.lonIdMunicipio),
      /**DOMICILIO**/

      /**MEDIOS CONTACTO**/
      "strTelefono": datosContacto.numeroTelefono,
      "strEmail": datosContacto.correoElectronico
      /**MEDIOS CONTACTO**/
    }

    const objeto = JSON.stringify(objetoFinal);


    Swal.fire({
      title: '¿Estás seguro que deseas guardar la información?',
      icon: 'question',
      confirmButtonColor: '#04B404',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      showCancelButton: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.value) {
        this.mostrarSpinner = true;

          //console.log("Objeto ->", objeto);
          this.solicitarCertificadoForenaeoService.solicitarCertificadoForaneoFisica(objeto).subscribe({
            next: (res: ResponsePropietarioFisica) =>{
              if (res.solicitudCertificadoError?.intCodigoHttp === 400) {
                  Swal.fire({
                    icon: 'error',
                    title: 'Error al enviar datos',
                    html: `<h4>${res.solicitudCertificadoError.strMensajeError}</h4>`,
                  });
                } else if (res.intCodigoHttp === 400) {
                  Swal.fire({
                    icon: 'error',
                    title: 'Error al enviar datos',
                    html: '<h4>No se pudo generar la solicitud. Verifique su información e inténtelo de nuevo.<br>Gracias.</h4>',
                  });
                } else if (res.intCodigoHttp === 200) {

                  sessionStorage.removeItem(this.STORAGE_KEY);
                  Swal.fire({
                    icon: 'success',
                    title: 'Solicitud enviada',
                    html: `Su solicitud ha sido enviada correctamente. <br><br>
                    Se ha enviado un correo electrónico a la dirección proporcionada <b style="color: #A11A5C">${correo}</b> para darle seguimiento.
                    <hr>Le recomendamos revisar su bandeja de entrada, así como la carpeta de spam o correo no deseado, en caso de no visualizar el mensaje.`,
                    confirmButtonColor: '#04B404',
                    confirmButtonText: 'Continuar',
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    allowOutsideClick: false,
                  });
                }
                this.mostrarSpinner = false;
            },
             error: (error: HttpErrorResponse) =>{
                this.mostrarSpinner = false;
              let message = DefaultErrorMessage;

              if(error instanceof HttpErrorResponse){
                const statusCode = error.status;

                // Si viene un código de error personalizado desde el backend:
                  const customCode = error.error?.codigo; // <- Esto depende de tu backend

                  if(customCode && ErrorMessages[customCode]){
                      message = ErrorMessages[customCode];
                  }else if (ErrorMessages[statusCode]) {
                    message = ErrorMessages[statusCode];
                  }
                }
              Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: message,

              }).then(() => {
                          location.reload(); // Recargar la página después de confirmar
                        });

              }
          });





      }
    });
  }

  //********************************** SOLICITUD *********************************************//

  onFileSelecteded1(input: HTMLInputElement, index:number): void {
    const file = input.files?.[0];

    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      this.archivoPDF1 = file;

      // const objectUrl = URL.createObjectURL(file);
      // this.pdfURL1 = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      // this.documentos[index].urlVisor = this.pdfURL1;
      // this.documentos[index].rawUrl = objectUrl;

      const datosPersona = this.SegundoGrupo.getRawValue();

      const rfc = datosPersona.rfc || '';
      const idDocument = this.documentos[index].id;
      const doc = this.documentos[index];
      const nombreArchivoAnterior = this.identificadoresAnteriores[index];
      const idDocumentoAnterior = this.idsDocumentoAnteriores[index];


       const subir = () => {
       const objectUrl = URL.createObjectURL(file);
       const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

    // Solo aquí actualizas iframe y variables visuales
    this.archivoPDF1 = file;
    this.pdfURL1 = pdfSafeUrl;
    this.documentos[index].urlVisor = this.pdfURL1;
    this.documentos[index].rawUrl = objectUrl;

    this.subirDocumento(rfc, idDocument, file, index);
  };

      // también string
      if (nombreArchivoAnterior) {
  // Mostrar confirmación al usuario
    Swal.fire({
    title: '¿Reemplazar archivo?',
    text: `Ya existe un archivo para "${doc.titulo}". ¿Deseas eliminar el anterior y subir el nuevo?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#41bd00',
    cancelButtonColor: '#C71128',
    confirmButtonText: 'Sí, reemplazar',
    cancelButtonText: 'No, cancelar'
  }).then((result) => {
    if (result.isConfirmed) {
      // Si el usuario confirma, eliminar el anterior
      this.eliminarDocumentosService.eliminarDocumentos(idDocumentoAnterior, rfc, nombreArchivoAnterior).subscribe({
        next: subir,
        error: () => {
          Swal.fire({
            icon: 'error',
            title: 'Error al eliminar documento anterior',
            text: `No se pudo eliminar el documento anterior para ${doc.titulo}.`,
            confirmButtonColor: '#A11A5C'
          });
        }
      });
    }
  });
} else {
  subir(); // Primera vez
  // Si no hay archivo anterior, subir directamente
  //this.subirDocumento(rfc, idDocument, file, index);
}

    }
  }

  // Método para manejo de evento al seleccionar
  archivoSelecionadoPDF1(event: Event, index: number): void {
    //console.log('Archivo seleccionado (evento):', event);
  }

  // Método para abrir el PDF en nueva ventana
  abrirPDFNewVentana1(): void {
    if (this.archivoPDF1) {
      const url = URL.createObjectURL(this.archivoPDF1);
      window.open(url, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }

  //********************************** FACTURA *********************************************//

  onFileSelecteded2(input: HTMLInputElement, index: number): void {
    const file = input.files?.[0];

    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      this.archivoPDF2 = file;

      // const objectUrl = URL.createObjectURL(file);
      // this.pdfURL2 = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      // this.documentos[index].urlVisor = this.pdfURL2;
      // this.documentos[index].rawUrl = objectUrl;

      const datosPersona = this.SegundoGrupo.getRawValue();
      const rfc = datosPersona.rfc || '';
      const idDocument = this.documentos[index].id;
      const doc = this.documentos[index];

      const nombreArchivoAnterior = this.identificadoresAnteriores[index];
      const idDocumentoAnterior = this.idsDocumentoAnteriores[index];

      const subir = () => {
        const objectUrl = URL.createObjectURL(file);
        const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

        this.archivoPDF2 = file;
        this.pdfURL2 = pdfSafeUrl;
        this.documentos[index].urlVisor = this.pdfURL2;
        this.documentos[index].rawUrl = objectUrl;

        this.subirDocumento(rfc, idDocument, file, index);
      }

     if (nombreArchivoAnterior) {
       // Mostrar confirmación al usuario
         Swal.fire({
         title: '¿Reemplazar archivo?',
         text: `Ya existe un archivo para "${doc.titulo}". ¿Deseas eliminar el anterior y subir el nuevo?`,
         icon: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#41bd00',
         cancelButtonColor: '#C71128',
         confirmButtonText: 'Sí, reemplazar',
         cancelButtonText: 'No, cancelar'
       }).then((result) => {
         if (result.isConfirmed) {
           // Si el usuario confirma, eliminar el anterior
           this.eliminarDocumentosService.eliminarDocumentos(idDocumentoAnterior, rfc, nombreArchivoAnterior).subscribe({
             next: subir,
             error: () => {
               Swal.fire({
                 icon: 'error',
                 title: 'Error al eliminar documento anterior',
                 text: `No se pudo eliminar el documento anterior para ${doc.titulo}.`,
                 confirmButtonColor: '#A11A5C'
               });
             }
           });
         }
       });
     } else {
      subir(); // Primera vez
       // Si no hay archivo anterior, subir directamente
       //this.subirDocumento(rfc, idDocument, file, index);
     }
    }
  }

  // Método para manejo de evento al seleccionar
  archivoSelecionadoPDF2(event: Event, index: number): void {
    //console.log('Archivo seleccionado (evento):', event);
  }

  // Método para abrir el PDF en nueva ventana
  abrirPDFNewVentana2(): void {
    if (this.archivoPDF2) {
      const url = URL.createObjectURL(this.archivoPDF2);
      window.open(url, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }

  //********************************** INE *********************************************//

  onFileSelecteded3(input: HTMLInputElement, index: number): void {
   const file = input.files?.[0];

    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      this.archivoPDF3 = file;

      // const objectUrl = URL.createObjectURL(file);
      // this.pdfURL3 = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      // this.documentos[index].urlVisor = this.pdfURL3;
      // this.documentos[index].rawUrl = objectUrl;

      const datosPersona = this.SegundoGrupo.getRawValue();

      const rfc = datosPersona.rfc || '';
      const idDocument = this.documentos[index].id;
      const doc = this.documentos[index];

      const nombreArchivoAnterior = this.identificadoresAnteriores[index];
      const idDocumentoAnterior = this.idsDocumentoAnteriores[index];

      const subir = () => {
        const objectUrl = URL.createObjectURL(file);
        const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

        this.archivoPDF3 = file;
        this.pdfURL3 = pdfSafeUrl;
        this.documentos[index].urlVisor = this.pdfURL3;
        this.documentos[index].rawUrl = objectUrl;
        this.subirDocumento(rfc, idDocument, file, index);
      }

     if (nombreArchivoAnterior) {
       // Mostrar confirmación al usuario
         Swal.fire({
         title: '¿Reemplazar archivo?',
         text: `Ya existe un archivo para "${doc.titulo}". ¿Deseas eliminar el anterior y subir el nuevo?`,
         icon: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#41bd00',
         cancelButtonColor: '#C71128',
         confirmButtonText: 'Sí, reemplazar',
         cancelButtonText: 'No, cancelar'
       }).then((result) => {
         if (result.isConfirmed) {
           // Si el usuario confirma, eliminar el anterior
           this.eliminarDocumentosService.eliminarDocumentos(idDocumentoAnterior, rfc, nombreArchivoAnterior).subscribe({
             next: subir,
             error: () => {
               Swal.fire({
                 icon: 'error',
                 title: 'Error al eliminar documento anterior',
                 text: `No se pudo eliminar el documento anterior para ${doc.titulo}.`,
                 confirmButtonColor: '#A11A5C'
               });
             }
           });
         }
       });
     } else {
      subir(); // Primera vez
       // Si no hay archivo anterior, subir directamente
       //this.subirDocumento(rfc, idDocument, file, index);
     }
    }

  }

  // Método para manejo de evento al seleccionar
  archivoSelecionadoPDF3(event: Event, index: number): void {
    //console.log('Archivo seleccionado (evento):', event);
  }

  // Método para abrir el PDF en nueva ventana
  abrirPDFNewVentana3(): void {
    if (this.archivoPDF3) {
      const url = URL.createObjectURL(this.archivoPDF3);
      window.open(url, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }

  //********************************** REPUVE *********************************************//

  onFileSelecteded4(input: HTMLInputElement, index:number): void {
    const file = input.files?.[0];
    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      this.archivoPDF4 = file;
      // const objectUrl = URL.createObjectURL(file);
      // this.pdfURL4 = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      // this.documentos[index].urlVisor = this.pdfURL4;
      // this.documentos[index].rawUrl = objectUrl;

      const datosPersona = this.SegundoGrupo.getRawValue();

      const rfc = datosPersona.rfc || '';
      const idDocument = this.documentos[index].id;
      const doc = this.documentos[index];

      const nombreArchivoAnterior = this.identificadoresAnteriores[index];
      const idDocumentoAnterior = this.idsDocumentoAnteriores[index];

      const subir = () => {
         const objectUrl = URL.createObjectURL(file);
         const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

        this.archivoPDF4 = file;
        this.pdfURL4 = pdfSafeUrl;
        this.documentos[index].urlVisor = this.pdfURL4;
        this.documentos[index].rawUrl = objectUrl;
        this.subirDocumento(rfc, idDocument, file, index);
      }

      if (nombreArchivoAnterior) {
        // Mostrar confirmación al usuario
          Swal.fire({
          title: '¿Reemplazar archivo?',
          text: `Ya existe un archivo para "${doc.titulo}". ¿Deseas eliminar el anterior y subir el nuevo?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#41bd00',
          cancelButtonColor: '#C71128',
          confirmButtonText: 'Sí, reemplazar',
          cancelButtonText: 'No, cancelar'
        }).then((result) => {
          if (result.isConfirmed) {
            // Si el usuario confirma, eliminar el anterior
            this.eliminarDocumentosService.eliminarDocumentos(idDocumentoAnterior, rfc, nombreArchivoAnterior).subscribe({
              next: subir,
              error: () => {
                Swal.fire({
                  icon: 'error',
                  title: 'Error al eliminar documento anterior',
                  text: `No se pudo eliminar el documento anterior para ${doc.titulo}.`,
                  confirmButtonColor: '#A11A5C'
                });
              }
            });
          }
        });
      } else {
        subir(); // Primera vez
        // Si no hay archivo anterior, subir directamente
        //this.subirDocumento(rfc, idDocument, file, index);
      }
    }
  }

  // Evento de selección (opcional)
  archivoSelecionadoPDF4(event: Event, index: number): void {

  }

  // Abrir PDF en nueva pestaña
  abrirPDFNewVentana4(): void {
    if (this.archivoPDF4) {
      const url = URL.createObjectURL(this.archivoPDF4);
      window.open(url, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }


  //********************************** REPUVE *********************************************//

  onFileSelecteded5(input: HTMLInputElement, index: number): void {
    const file = input.files?.[0];
    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      this.archivoPDF5 = file;
      // const objectUrl = URL.createObjectURL(file);
      // this.pdfURL5 = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      // this.documentos[index].urlVisor = this.pdfURL5;
      // this.documentos[index].rawUrl = objectUrl;

      const datosPersona = this.SegundoGrupo.getRawValue();

      const rfc = datosPersona.rfc || '';
      const idDocument = this.documentos[index].id;
      const doc = this.documentos[index];

      const nombreArchivoAnterior = this.identificadoresAnteriores[index];
      const idDocumentoAnterior = this.idsDocumentoAnteriores[index];

      const subir = () => {
        const objectUrl = URL.createObjectURL(file);
        const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

        this.archivoPDF5 = file;
        this.pdfURL5 = pdfSafeUrl;
        this.documentos[index].urlVisor = this.pdfURL5;
        this.documentos[index].rawUrl = objectUrl;
        this.subirDocumento(rfc, idDocument, file, index);
      }

     if (nombreArchivoAnterior) {
       // Mostrar confirmación al usuario
         Swal.fire({
         title: '¿Reemplazar archivo?',
         text: `Ya existe un archivo para "${doc.titulo}". ¿Deseas eliminar el anterior y subir el nuevo?`,
         icon: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#41bd00',
         cancelButtonColor: '#C71128',
         confirmButtonText: 'Sí, reemplazar',
         cancelButtonText: 'No, cancelar'
       }).then((result) => {
         if (result.isConfirmed) {
           // Si el usuario confirma, eliminar el anterior
           this.eliminarDocumentosService.eliminarDocumentos(idDocumentoAnterior, rfc, nombreArchivoAnterior).subscribe({
             next: subir,
             error: () => {
               Swal.fire({
                 icon: 'error',
                 title: 'Error al eliminar documento anterior',
                 text: `No se pudo eliminar el documento anterior para ${doc.titulo}.`,
                 confirmButtonColor: '#A11A5C'
               });
             }
           });
         }
       });
     } else {
      subir(); // Primera vez
       // Si no hay archivo anterior, subir directamente
       //this.subirDocumento(rfc, idDocument, file, index);
     }
    }
  }

  // Evento de selección (opcional)
  archivoSelecionadoPDF5(event: Event, index: number): void {
    //console.log('Archivo seleccionado (evento):', event);
  }

  // Abrir PDF en nueva pestaña
  abrirPDFNewVentana5(): void {
    if (this.archivoPDF5) {
      const url = URL.createObjectURL(this.archivoPDF5);
      window.open(url, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }
  //********************************FUNCIONES*********************************************** */

  // Méto do que "transfiere" valor automáticamente del RFC al CURP
  pasarValorRfcACurp(): void {
    const rfc = this.SegundoGrupo.get('rfc')?.value;

    if (rfc && rfc.length >= 10) {
      const curpParcial = rfc.substr(0, 10).toUpperCase(); // Convertir a mayúsculas
      this.SegundoGrupo.get('curp')?.setValue(curpParcial);
    } else {
      // Caso en que el RFC no tenga los caracteres necesarios
      this.SegundoGrupo.get('curp')?.setValue('');
    }
  }

  // funcion para abrir modal curp
  modalCURP() {
    Swal.fire({
      background: 'rgba(161, 26, 92)',
      imageUrl: '/assets/img/imagenesCuerpo/CURP.png',
      imageWidth: '95%',
      imageHeight: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      width: '60%',
      showClass: {
        popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `,
      },
      hideClass: {
        popup: `
                  animate__animated
                  animate__fadeOutDown
                  animate__faster
                `,
      },
    });
  }

  // funcion para abrir modal rfc
  modalRFCFISICA() {
    Swal.fire({
      background: 'rgba(161, 26, 92)',
      imageUrl: '/assets/img/imagenesCuerpo/RFCFISICA.png',
      imageWidth: '95%',
      imageHeight: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      width: '60%',
      showClass: {
        popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `,
      },
      hideClass: {
        popup: `
                  animate__animated
                  animate__fadeOutDown
                  animate__faster
                `,
      },
    });
  }

  // funcion para descargar documento


  // funcion para extraer la fecha nacimento del rfc
  extractBirthday(): void {
    const rfc: string = this.SegundoGrupo.get('rfc')?.value;

    if (rfc && rfc.length >= 10) {
      // Obtener el año (posiciones 5 y 6 del RFC)
      let anio: string = rfc.substring(4, 6).trim();
      const anioInt: number = parseInt(anio, 10);

      if (anioInt > new Date().getFullYear() % 100 || anio === '00') {
        anio = (anio === '00') ? '2000' : '19' + anio;
      } else {
        anio = '20' + anio;
      }

      // Obtener mes y día
      const mes: string = rfc.substring(6, 8).trim();
      const dia: string = rfc.substring(8, 10).trim();

      const fechaNacimiento = `${anio}-${mes}-${dia}`;
      this.SegundoGrupo.get('fechaNacimiento')?.setValue(fechaNacimiento);
    } else {
      this.SegundoGrupo.get('fechaNacimiento')?.setValue('');
    }
  }

  // funcion para extraer el sexo del CURP
  extraerSexoDesdeCurp(): void {
    const curp: string = this.SegundoGrupo.get('curp')?.value;

    if (curp && curp.length >= 18) {
      const sexo = curp.charAt(10).toUpperCase();

      if (sexo === 'H') {
        this.SegundoGrupo.get('sexo')?.setValue('M');
      } else if (sexo === 'M') {
        this.SegundoGrupo.get('sexo')?.setValue('F');
      } else {
        this.SegundoGrupo.get('sexo')?.setValue('');
      }
    } else {
      this.SegundoGrupo.get('sexo')?.setValue('');
    }
  }
}
